import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Layout from './components/layout/Layout';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AppRoutes from './routing/AppRoutes';
import LoginModal from './pages/Login/login';
import SignupModal from './pages/SignUp/Signup';
import { ModalProvider } from './context/ModalContext';
import { ToastContainer } from 'react-toastify';
import AOS from "aos";
import { useEffect, useCallback } from 'react';
import "aos/dist/aos.css";
import { UserProvider } from './context/LoginDetail';
import { SettingsProvider } from './context/Settings';
import { HelmetProvider } from 'react-helmet-async';


// ── Static event handlers — hoisted outside component to prevent recreation ──
const handleKeyDown = (e) => {
  if (e.target.type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
    e.preventDefault();
  }
};

const handleWheel = (e) => {
  if (e.target.type === "number") {
    e.target.blur();
  }
};

function App() {

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <HelmetProvider>
      <UserProvider>
        <SettingsProvider>
          <ModalProvider>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            <Layout>
              <AppRoutes />
            </Layout>
          </ModalProvider>
        </SettingsProvider>
      </UserProvider>
    </HelmetProvider>
  );
}

export default App;
